import type { TooltipStylesType } from '@material-tailwind/react';

const styles: TooltipStylesType = {
  defaultProps: {
    placement: 'top',
  },
  styles: {
    base: {
      color: 'bg-slate-500 before:bg-slate-500 text-white',
      alignment: 'text-center whitespace-normal max-w-150',
      layer: 'z-[1] before:z-[-1]',
    },
  },
};

export default styles;
